import React from 'react';
import fb from "../../assets/images/social-media/fb.jpg"
import tweet from "../../assets/images/social-media/tweet.jpg"
import insta from "../../assets/images/social-media/insta.jpg"
import printest from "../../assets/images/social-media/pinterest.jpg"
import linkedin from "../../assets/images/social-media/linkedin.jpg"
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import '../../footernew.css';

const FooterNew = (props) => {
    const gotoHome = () => {
        window.location.href = '/';
    }
    const FooterX = styled.div`
    background: #FFFFFF;
    border: 1px solid #000000;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 3.8vh 1.83vw 3.8vh 1.5vw;
    height: 8.67vh;
    position: absolute;
    width: 100vw;
    `
    return (
        <FooterX className="footer" full={props.full}>

            <Links className="link">
                <Link to="/about" style={{ textDecoration: 'none' }}><p style={{ fontSize: '13px', fontWeight: '400', marginRight: '4.5vw' }}>About Us</p></Link>
                <Link to="/contact" style={{ textDecoration: 'none' }}><p style={{ fontSize: '13px', fontWeight: '400', marginRight: '4.5vw' }}>Contact</p></Link>
                <Link to="/terms" style={{ textDecoration: 'none' }}><p style={{ fontSize: '13px', fontWeight: '400', marginRight: '4.5vw' }}>Terms Of Service</p></Link>
                <Link to="/privacy" style={{ textDecoration: 'none' }}><p style={{ fontSize: '13px', fontWeight: '400', marginRight: '4.5vw' }}>Privacy Policy</p></Link>
                <Link to="/faq" style={{ textDecoration: 'none' }}><p style={{ fontSize: '13px', fontWeight: '400', marginRight: '4.5vw' }}>FAQ’s</p></Link>


            </Links>

            <Social className="social" style={{ marginLeft: '5vw' }}>
                <a href="https://www.facebook.com/priyanka.chatterjee9075/" target='_blank'><img src={fb} alt="fb" onClick={gotoHome} style={{ cursor: 'pointer' }} /></a>
                <a href="https://www.instagram.com/pri_chatterjee/" target='_blank'><img src={insta} alt="insta" onClick={gotoHome} style={{ cursor: 'pointer' }} /></a>
                <a href="https://www.linkedin.com/in/priyanka-9075/" target='_blank'><img src={linkedin} alt="linkedin" onClick={gotoHome} style={{ cursor: 'pointer' }} /></a>
                <a href="#"><img src={tweet} alt="tweet" onClick={gotoHome} style={{ cursor: 'pointer' }} /></a>
                {/* <a href="https://in.pinterest.com/kredeycompany/_saved/"><img src={printest} alt="printest" onClick={gotoHome} style={{ cursor: 'pointer' }} /></a> */}

            </Social>
            <p style={{ fontSize: '11px', marginTop: '2vh', cursor: 'default' }}>Copyright &#169;2021 Friend a Book | Made with 💖 by <a target='_blank' href="https://github.com/Priyanka-Chatterjee-2000">Pri</a></p>

        </FooterX>
    )
}

// ===========================Styled components===================

const Links = styled.div`
    display: flex;
    flex-direction: row;
`

const Social = styled(Links)`
    align-items: center;
    position:relative;
    right:7.32vw;
    img{
        position: relative;
    width: 1.9vw;
    height: 3.8vh; 
    margin-left: 0.73vw;
    margin-right: 1.1vw; 
    }
`


export default FooterNew;